import React from 'react';
import './style.css';
import {
  Link
} from "react-router-dom";

// fix countdown on smaller screen
// Timed out waiting for start_url (https://sarahpeterson.dev/sarahpeterson.dev) to respond.
// test for speed again
// make the home sections a reusable component

function Home() {
  return (
    <main className="App">
      <div className="border">
        <p className="home-text bottom">Sarah Peterson,</p>
        <p className="home-text top">Developer</p>
      </div>
      <div>
        <div className="menu-wrap">
          <div className="menu-container">
            <p className="menu-header">
              Sarah
            </p>
            <div className="menu-item">
              <a
                className="menu-link"
                href="mailto:sarahmasonpeterson@gmail.com"
                alt="Sarah's Email"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  Email
                </p>
              </a>
              <p className="menu-spacing">/</p>
              <a
                className="menu-link"
                href="https://www.linkedin.com/in/sarah-peterson-4444b946/"
                alt="Sarah's LinkedIn"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  LinkedIn
                </p>
              </a>
              <p className="menu-spacing">/</p>
              <a
                className="menu-link"
                href="/SarahPetersonResume.pdf"
                alt="Sarah's Resume"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  Resume
                </p>
              </a>
              <p className="menu-spacing">/</p>
              <a
                className="menu-link"
                href="https://github.com/sarahpeterson"
                alt="Sarah's GitHub"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  GitHub
                </p>
              </a>
            </div>
            <p className="menu-description-main">
              Sarah is a Front End Developer based in Pittsburgh, PA. She is proficient in
              React, React Native, HTML, CSS, JavaScript, Sketch, Figma and UI Design.
              You can reach Sarah and learn more about her at the links above.
            </p>
          </div>
          <div className="menu-container">
            <p className="menu-header">
              Sizzle, AI
            </p>
            <div className="menu-item">
            <a
                className="menu-link"
                href="web.szl.ai"
                alt="Sizzle AI's website"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  Website
                </p>
              </a>
              <p className="menu-spacing">/</p>
              <a
                className="menu-link"
                href="https://apps.apple.com/us/app/sizzle-learn-anything/id6449232300"
                alt="Sizzle app in the Apple Store"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  Apple App Store
                </p>
              </a>
            </div>
            <div className="example-section">
            
            <img src="SizzleHome.png" className="example-image"/>
           
            <p className="menu-description">
             Working closely with a designer, Sarah led and executed the redesign of Sizzle's marketing website. 
             Sarah was part of the small team that implemented monetization in the Sizzle mobile app in early 2025. Today, Sizzle has over 100 subsribers and counting. In late 2024, Sarah advocated for the need for a design system to be used in the building of the Sizzle mobile app. Working closely with the designer, Sarah built reusable text, button, header and more components. This has saved the engineering team time as we implemented new features and A/B testing.
            </p>
          </div>
          </div>
          <div className="menu-container" style={{ marginTop: 40}}>
            <p className="menu-header">
              Potted
            </p>
            <div className="menu-item">
              <a
                className="menu-link"
                href="https://pottedpgh.com"
                alt="Potted's website"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  Website
                </p>
              </a>
              <p className="menu-spacing">/</p>
              <a
                className="menu-link"
                href="/PottedSite.pdf"
                alt="Potted's designs"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  Design
                </p>
              </a>
              <p className="menu-spacing">/</p>
              <a
                className="menu-link"
                href="https://github.com/sarahpeterson/pottedpgh"
                alt="Potted's GitHub"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  GitHub
                </p>
              </a>
            </div>

            <div className="example-section">
            
            <img src="PottedHome.png" className="example-image"/>
            <p className="menu-description">
              Potted is a shared passion side project that Sarah is working on
              with a friend as a way to share their knowledge of house plants.
              Sarah designed the website and built it in React.
            </p>
            </div>
          </div>
         
          <div className="menu-container" style={{ marginTop: 40}}>
            <p className="menu-header">
              Accomplish Reading
            </p>
            <div className="menu-item">
              <a
                className="menu-link"
                href="https://apps.apple.com/us/app/accomplish-reading/id977303261?ign-mpt=uo%3D4"
                alt="Link to app in Apple App Store"
                rel="noopener noreferrer"
                target="_blank"
              >
                <p>
                  Apple App Store
                </p>
              </a>
            </div>
            <div className="example-section">
            
            <img src="AccomplishReadingHome.png" className="example-image-height"/>
            <p className="menu-description">
              Sarah was the lead developer and tech lead on the development of this app
              for a client at a previous job. It was built using React Native, Redux and Persist. The customer
              did not want a backend or database so the app saves all data locally with Persist.
             
              The client, a retired teacher, now has over over 600 downloads for the app from multiple educational institutions across the country and in Ireland.
            </p>
          </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Home;
